import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { CommissionService } from '@app/shared/components/requests/commissions/service/commission.service';
import { RequestAmountRange } from '@app/shared/models';
import { CommissionActionType } from '@app/shared/types/commission/commission-action-type.enum';
import { CommissionFormParam } from '../../models/commission-form-params';
import { RequestType } from './../../../../../types/request-type';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CountdownComponent } from '@app/shared/components/countdown/countdown.component';
import { TableLoadingComponent } from '@app/shared/components/table-loading/table-loading.component';
import { CommissionExchangeLastComponent } from '../commission-exchange-last/commission-exchange-last.component';
import { CommissionExchangeFirstComponent } from '../commission-exchange-first/commission-exchange-first.component';

@Component({
  selector: 'tc-commission',
  imports: [
    CommonModule,
    TranslateModule,
    CountdownComponent,
    TableLoadingComponent,
    CommissionExchangeLastComponent,
    CommissionExchangeFirstComponent
  ],
  templateUrl: './commission.component.html',
  styleUrls: ['./commission.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CommissionComponent implements OnInit, OnChanges {
  @Output() requestAmountRangeEmit = new EventEmitter<RequestAmountRange>();
  @Output() amountIsSuccessEmit = new EventEmitter<boolean>();
  @Output() resultCommissionEmit = new EventEmitter<any>();
  @Input() formParams: CommissionFormParam;
  @Input() showCommissionFirst: boolean;
  @Input() showCommissionLast: boolean;
  @Input() isDetailsMode: boolean;
  @Input() requestType: RequestType;

  @Input() getAmountTitle: string;
  @Input() payAmountTitle: string;

  commissionResult: any;

  interval: number;

  // boolean
  calculateLoading: boolean;
  commissionIsExpired = false;

  constructor(
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    private commissionService: CommissionService
  ) { }

  /*******************************************************************
  Lifecycle Hook
   *******************************************************************/


  ngOnInit(): void {
    this.getCommissionResult();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.formParams) {
      return;
    }
    if (changes.formParams.firstChange) {
      this.getCommission(true);
      return;
    }

    if (!this.formParams) {
      this.commissionResult = null;
    }
    if (this.formParams && !this.formParams.amount) {
      this.formParams.amount = 0;
    }

    if (changes.formParams && changes.formParams.previousValue && this.formParams && changes.formParams.previousValue.amount !== this.formParams.amount) {
      this.getCommission();
      return;
    }
    this.getCommission(true);

  }

  /*******************************************************************
   Private
  *******************************************************************/

  private getCommissionGroup(): void {
    if (!this.formParams) {
      return;
    }

    // set url base on request type
    let url = `${this.appConfig.apiEndpoint}/new-core`;
    this.calculateLoading = true;
    switch (this.formParams.requestType) {

      case RequestType.Deposit:
        if (this.formParams.actionType === CommissionActionType.SELL_SERVICE) {
          url += '/commissions/deposit/service';
        } else {
          // url += '/Commissions/Deposit/MoneyCurrency';
        }
        break;

      case RequestType.Withdrawal:
        if (this.formParams.actionType === CommissionActionType.BUY_SERVICE) {
          url += '/commissions/withdraw/service';
        } else {
          url += '/commissions/withdraw/money-currency';
        }
        break;

      case RequestType.Send:
        if (this.formParams.actionType === CommissionActionType.INTERNAL_TRANSFER) {
          url += '/commissions/transfers/tc-wallet';
        } else {
          // url += '/Commissions/Send/MoneyCurrency';
        }
        break;

      case RequestType.Exchange:
        url += '/commissions/exchange/tc-wallet';
        break;

    }

    //get commission group
    if (!this.showCommissionFirst) {
      this.commissionService.getCommissionGroup(this.formParams, url, false);
      return;
    }
    this.commissionService.getCommissionGroup(this.formParams, url, true);
  }

  private setInterval(): void {
    if (this.commissionResult) {
      this.interval = Math.floor(this.commissionResult.refreshTime / 1000);
    }
  }

  private getCommission(needNewRates?: boolean): void {
    if (this.commissionIsExpired || !this.commissionResult || !this.commissionResult.success || needNewRates) {
      this.getCommissionGroup();
    } else {
      this.commissionService.formParams = this.formParams;
      this.commissionService.setCommissionResult();
    }

  }

  private getCommissionResult(): void {
    this.commissionService.commissionResult$
      .pipe()
      .subscribe(
        res => {
          if (!this.formParams) {
            this.commissionResult = null;
            return;
          }
          this.commissionResult = res;
          if (!res) {
            return;
          }

          this.calculateLoading = false;
          if (this.commissionResult.amountIsWrong) {
            const requestAmountRange: RequestAmountRange = {
              maxAmount: this.commissionResult.maxAmount,
              minAmount: this.commissionResult.minAmount,
              amount: this.formParams.amount,
              currencyCode: this.formParams.fromCurrencyData.code,
              precision: this.formParams.fromCurrencyData.precision
            }
            this.requestAmountRangeEmit.emit(requestAmountRange);
            this.amountIsSuccessEmit.emit(false);
          } else {
            this.amountIsSuccessEmit.emit(true);
             this.resultCommissionEmit.emit(this.commissionResult);
          }

          if (this.commissionResult && this.commissionResult.success && (this.commissionIsExpired || !this.interval)) {
            this.setInterval();
            this.commissionIsExpired = false;
          }
        }
      )
  }

  /*******************************************************************
   Public
  *******************************************************************/

  onTimerFinished(): void {
    this.commissionIsExpired = true;
    this.getCommission();
  }



}
